module.exports = __webpack_public_path__ + "img/account-manage.b706302f.svg";